import React from 'react'
import { GifName, gifSrc } from '../../../data/gifs'

type Props = {
  gif: GifName
  // A still of the GIF's first frame, same canvas size, shown until the GIF loads.
  still: string
  style?: React.CSSProperties
}

// Shows the still straight away and swaps in the animated GIF once the page has
// finished loading, so a large animation never delays the first screen.
export const DeferredGif: React.FC<Props> = ({ gif, still, style }) => {
  const [src, setSrc] = React.useState(still)

  React.useEffect(() => {
    let cancelled = false
    const load = () => {
      const animated = new Image()
      animated.onload = () => !cancelled && setSrc(gifSrc(gif))
      animated.src = gifSrc(gif)
    }
    if (document.readyState === 'complete') load()
    else window.addEventListener('load', load, { once: true })
    return () => {
      cancelled = true
      window.removeEventListener('load', load)
    }
  }, [gif])

  return <img src={src} alt="" aria-hidden style={style} />
}
